import HomePageCarouselItem from './homePageCarousellItem/homePageCarouselItem.vue'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'

export default {
  props: {
    dataProvider: {
      type: Function
    },
    trackEventDataAccessor: {
      type: Function
    },
    title: {
      type: String
    },
    event_id: {
      type: String
    }
  },
  components: {
    HomePageCarouselItem,
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      isCarouselVisible: true,
      carouselInnerWidth: 0,
      items: []
    }
  },
  methods: {
    carouselInitCallback,
    updateCarouselVisibility
  },
  async beforeMount() {
    this.items = await this.dataProvider()
  },
  mounted() {
    window.addEventListener('resize', this.updateCarouselVisibility)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateCarouselVisibility)
  },
  computed: {
    carousel() {
      return this.$refs.carousel.$swiper
    },
    carouselOptions() {
      const halfFactor = 2

      return {
        slidesPerView: 'auto',
        spaceBetween: 0,
        freeMode: true,
        initialSlide: this.items.length / halfFactor,
        centeredSlides: true,
        centeredSlidesBounds: true,
        pagination: {
          el: '.swiper-pagination'
        }
      }
    }
  }
}

function carouselInitCallback() {
  this.carouselInnerWidth = Array.from(this.carousel.$wrapperEl[0].children).reduce(
    (total, current) => total + current.offsetWidth,
    0
  )
  this.updateCarouselVisibility()
}

function updateCarouselVisibility() {
  this.isCarouselVisible = window.innerWidth < this.carouselInnerWidth
}
